import { partnerExaminationPageUrlParams } from 'pages/Partner/PartnerExaminationPage';
import { sharedExaminationPageUrlParams } from 'pages/Shared/SharedExaminationPage';
import { sharedVisitPageUrlParams } from 'pages/Shared/SharedExaminationPage/SharedVisitPage';

export const routes = {
  root: '/',
  opsHealth: '/ops/health',
  setNewPassword: '/set-new-password/:token',

  user: {
    root: '/user',
    setPin: '/user/set-pin/:token',
  },

  patient: {
    root: '/patient',
    setPin: '/patient/set-pin/:token',
  },

  shared: {
    root: '/shared/*',
    examination: `examination/:${sharedExaminationPageUrlParams.sharingToken}`,
    visit: `visit/:${sharedVisitPageUrlParams.sharingToken}`,
  },

  partnerExam: {
    root: '/partner/*',
    examination: `examination/:${partnerExaminationPageUrlParams.otp}`,
  },

  partnerVisit: {
    root: '/partner/*',
    visit: `visit/:${partnerExaminationPageUrlParams.otp}`,
  },
};
